import { dialog } from "../../../../../../nq-component";
import React from "react";

function DialogReceive({ index, onClickPartial, onClickReceiveAll }) {
  return (
    <div className="rounded-3 overflow-hidden" style={{ minWidth: "380px" }}>
      {/* Header */}
      <div
        className="px-4 py-3 d-flex align-items-center gap-3"
        style={{
          background: "linear-gradient(135deg, #82c14a 0%, #6ba83a 100%)",
        }}
      >
        <div
          className="d-flex align-items-center justify-content-center rounded-circle"
          style={{
            width: "42px",
            height: "42px",
            background: "rgba(255,255,255,0.2)",
          }}
        >
          <i
            className="bi bi-inbox text-white"
            style={{ fontSize: "1.2rem" }}
          />
        </div>
        <div className="flex-grow-1">
          <h6
            className="mb-0 text-white fw-bold"
            style={{ fontSize: "0.95rem" }}
          >
            Confirm Receiving Items
          </h6>
          <small
            style={{ color: "rgba(255,255,255,0.8)", fontSize: "0.75rem" }}
          >
            Choose how to receive the items
          </small>
        </div>
        <button
          className="btn-close btn-close-white"
          style={{ opacity: 0.8 }}
          aria-label="Close"
          onClick={() => dialog.close()}
        />
      </div>

      {/* Body */}
      <div className="px-4 py-4" style={{ background: "#fff" }}>
        <p
          className="mb-4 text-center"
          style={{ fontSize: "0.9rem", color: "#4b5563" }}
        >
          How would you like to receive the items? You can choose to receive all
          or partially receive.
        </p>

        <div className="d-flex gap-3">
          {/* Partial Receive Card */}
          <div
            className="flex-fill rounded-3 p-3 text-center"
            role="button"
            style={{
              border: "2px solid #e5e7eb",
              background: "#f9fafb",
              cursor: "pointer",
              transition: "all 0.2s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = "#d97706";
              e.currentTarget.style.background = "#fffbeb";
              e.currentTarget.style.transform = "translateY(-2px)";
              e.currentTarget.style.boxShadow =
                "0 4px 12px rgba(217,119,6,0.15)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = "#e5e7eb";
              e.currentTarget.style.background = "#f9fafb";
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "none";
            }}
            onClick={() => onClickPartial(index)}
          >
            <div
              className="d-flex align-items-center justify-content-center rounded-circle mx-auto mb-2"
              style={{
                width: "48px",
                height: "48px",
                background: "#fef3c7",
                color: "#d97706",
              }}
            >
              <i className="bi bi-pie-chart" style={{ fontSize: "1.2rem" }} />
            </div>
            <span
              className="fw-bold d-block"
              style={{ fontSize: "0.85rem", color: "#374151" }}
            >
              Partial Receive
            </span>
            <small className="text-muted" style={{ fontSize: "0.72rem" }}>
              Receive some items now
            </small>
          </div>

          {/* Receive All Card */}
          <div
            className="flex-fill rounded-3 p-3 text-center"
            role="button"
            style={{
              border: "2px solid #a3d977",
              background: "#edf7e1",
              cursor: "pointer",
              transition: "all 0.2s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = "#82c14a";
              e.currentTarget.style.background = "#e0f2d0";
              e.currentTarget.style.transform = "translateY(-2px)";
              e.currentTarget.style.boxShadow =
                "0 4px 12px rgba(130,193,74,0.25)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = "#a3d977";
              e.currentTarget.style.background = "#edf7e1";
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "none";
            }}
            onClick={() => onClickReceiveAll(index)}
          >
            <div
              className="d-flex align-items-center justify-content-center rounded-circle mx-auto mb-2"
              style={{
                width: "48px",
                height: "48px",
                background: "#82c14a",
                color: "#fff",
              }}
            >
              <i
                className="bi bi-check-circle"
                style={{ fontSize: "1.2rem" }}
              />
            </div>
            <span
              className="fw-bold d-block"
              style={{ fontSize: "0.85rem", color: "#374151" }}
            >
              Receive All
            </span>
            <small className="text-muted" style={{ fontSize: "0.72rem" }}>
              Receive all items at once
            </small>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DialogReceive;
